
import React, {  useState,useEffect, createContext } from "react";
// import {getFromLocalStorage} from '../components/helper/task'
const TotalViewContext=createContext()

const TotalViewProvider=({children})=>{
    
    const [totalView,setTotalView]=useState({total:0,totalView:0});

        

    return(
    <TotalViewContext.Provider value={[totalView,setTotalView]}>
        {children}
    </TotalViewContext.Provider>)
}

export {TotalViewContext,TotalViewProvider}
